<template>
    <div id="app" class="scrollbar_style" @scroll="onScroll($event)">
        <headers></headers>
        <div class="router_box">
            <!-- <side-bar v-show="sideBarShow"></side-bar> -->
            <router-view></router-view>
            <bottom-navbar></bottom-navbar>
        </div>
    </div>
</template>

<script type="text/javascript">
    Date.prototype.format = function(fmt) { 
        let ret;
        const opt = {
            "Y+": this.getFullYear().toString(),        // 年
            "m+": (this.getMonth() + 1).toString(),     // 月
            "d+": this.getDate().toString(),            // 日
            "H+": this.getHours().toString(),           // 时
            "M+": this.getMinutes().toString(),         // 分
            "S+": this.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
        }
        return fmt; 
    }
    
    import headers from './components/header.vue'
    import bottomNavbar from './components/bottomNavbar.vue'
    // import allUrl from './api/allUrl.js'
    // import base from './api/base.js'
    import { mapGetters } from 'vuex'
    // import $ from  'jquery'
    // import mCustomScrollbar from './api/jquery.mCustomScrollbar.concat.min.js'

    export default {
        name:'App',
        data(){
            return{
                i18nArr:['zh-CN','en-US'],
                linkTypeData:{},
            }
        },
        computed:{
            ...mapGetters({
                version:'version',
                linkToType:'linkToType',
                remRatio:'remRatio',
                sideBarShow:'sideBarShow',
                updateRemRatio:'updateRemRatio',
                lastScrollTop:'lastScrollTop'

            }),
        },
        components:{
            'headers':headers,
            'bottom-navbar':bottomNavbar,
        },
        created(){
            if(this.version == '0'){
                document.title = this.$t('App.documentTitle');
            }
            // this.versionFun(this.version)
            // console.log(this.version,'-111-555-')
            this.$router.beforeEach((to, from, next) => {
                // console.log(to.path,'--------')
                // if(to.path == '/login'||to.path == '/retrievePassword'){
                //     this.headersShow = false
                // }else{
                //     this.headersShow = true
                // }

                // if(this.version == '1'){
                //     document.title = 'inHealth-'+this.linkTypeData[to.path]
                // }
                if(this.version == '0'){
                    document.title = this.$t('App.documentTitle');
                }
                this.$store.commit('linkToTypeFun',{
                    linkToType:to.path
                })

                next();
            })
            
        },
        mounted(){
            let this_ = this;
            let width = document.body.offsetWidth;
            if(width<1440){
                width = 1440
            }
            $('html').css({ 'font-size': width * 62.5 / 1263.2 + '%' })
            this_.$store.commit('REMRATIOFUN', {
                remRatio: width * 62.5 / 1263.2 / 100 * 16,
            })

            if($('.template_box').width()<$('.box_width').width()){
                $('.box_width').css({'left':($('.template_box').width()-($('.box_width').width()))/2+'px'})
            }else{
                $('.box_width').css({'left': 0+'px'})
            }
            window.onresize = function(){
                width = document.body.offsetWidth;
                if(width<1440){
                    width = 1440
                }
                $('html').css({ 'font-size': width * 62.5 / 1263.2 + '%' })
                this_.$store.commit('REMRATIOFUN', {
                    remRatio: width * 62.5 / 1263.2 / 100 * 16,
                })
                this_.$store.commit('UPDATEREMRATIOFUN',{
                    updateRemRatio:this_.updateRemRatio+1,
                })

                if($('.template_box').width()<$('.box_width').width()){
                    $('.box_width').css({'left':($('.template_box').width()-($('.box_width').width()))/2+'px'})
                }else{
                    $('.box_width').css({'left': 0+'px'})
                }
            }
        },
        methods:{
            onScroll(e){
                // console.log(e,e.target,e.target.scrollTop)
                // console.log(3.95*this.remRatio,e.target.scrollTop)
                const currentScrollTop = e.target.scrollTop;

                if(e.target.scrollTop>3.95*this.remRatio){

                    if (currentScrollTop > this.lastScrollTop) {
                        // 向下滚动
                        // console.log('向下滚动');
                        this.$store.commit('scrollTypeFun', {
                            scrollType: 'up',
                        })
                    } else {
                        this.$store.commit('scrollTypeFun', {
                            scrollType: 'down',
                        })
                        // 向上滚动
                        // console.log('向上滚动');
                    }
                }
                this.$store.commit('lastScrollTopFun', {
                    lastScrollTop: currentScrollTop,
                })
            },
            versionFun(val){
                // this.$store.commit('VERSION',{
                //     version:val,
                // })
                if(val == '0'){
                    this.$i18n.locale = 'zh-CN'
                }
                if(val == '1'){
                    this.$i18n.locale = 'en-US'
                }
            },
            loadJS( url, callback ){
                let script = document.createElement('script'),
                fn = callback || function(){};
                script.type = 'text/javascript';
                //IE
                if(script.readyState){
                  script.onreadystatechange = function(){
                    if( script.readyState == 'loaded' || script.readyState == 'complete' ){
                      script.onreadystatechange = null;
                      fn();
                    }
                  };
                }else{
                  //其他浏览器
                  script.onload = function(){
                    fn();
                  };
                }
                script.src = url;
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        }
    }
</script>

<style type="text/css" lang="less">
    @font-face {
        font-family: 'PingFang-SC-Medium';
        src: url('./style/font-pf/PingFang Medium.ttf');
        // src:
        //   url('./style/font-pf/PingFangRegular.eot?#font-spider') format('embedded-opentype'),
        //   url('./style/font-pf/PingFangRegular.woff') format('woff'),
        //   url('./style/font-pf/PingFangRegular.ttf') format('truetype'),
        //   url('./style/font-pf/PingFangRegular.svg') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: 'PingFang-SC-Bold';
        src: url('./style/font-pf/PingFang Bold.ttf');
        // src:
        //   url('./style/font-pf/PingFangRegular.eot?#font-spider') format('embedded-opentype'),
        //   url('./style/font-pf/PingFangRegular.woff') format('woff'),
        //   url('./style/font-pf/PingFangRegular.ttf') format('truetype'),
        //   url('./style/font-pf/PingFangRegular.svg') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'PingFang-SC-Regular';
        src: url('./style/font-pf/PingFang Regular.ttf');
        // src:
        //   url('./style/font-pf/PingFangHeavy.eot?#font-spider') format('embedded-opentype'),
        //   url('./style/font-pf/PingFangHeavy.woff') format('woff'),
        //   url('./style/font-pf/PingFangHeavy.ttf') format('truetype'),
        //   url('./style/font-pf/PingFangHeavy.svg') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'PingFang-SC-Heavy';
        src: url('./style/font-pf/PingFang Heavy.ttf');
        // src:
        //   url('./style/font-al/Alibaba-PuHuiTi-Regular.eot?#font-spider') format('embedded-opentype'),
        //   url('./style/font-al/Alibaba-PuHuiTi-Regular.woff') format('woff'),
        //   url('./style/font-al/Alibaba-PuHuiTi-Regular.ttf') format('truetype'),
        //   url('./style/font-al/Alibaba-PuHuiTi-Regular.svg') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiH';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiB';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiL';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Light.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiM';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'bodoni-MT';
    //     src: url('./style/bodoniMT/bodoniMT.ttf');
    // }

    html,body,p,h1,h2,h3,h4,h5,ul,li{
        margin: 0px;
        padding: 0px;
    }
    html,body,#app{
          height: 100%;
          width:100%;
    }
    li{
        list-style:none;/*li去点*/
        box-sizing: border-box;
    }
    a{
        text-decoration: none;
        box-sizing: border-box;
    }
    i{
        font-style: inherit;
    }
    input{
        padding:0;
        outline-style: none;
        box-sizing: border-box;
    }
    div{
        box-sizing: border-box; //border、padding并入宽度。
    }
      /*滚动条样式*/
    .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
        width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 10px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 8px;
        background: #DAE6E0;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    .el-table{
        th>.cell,td>.cell{
            padding: 0;
        }
        .el-table__body-wrapper{
            width: calc(100% - 8px);
            margin-right: 8px;
        }
    }
    .el-time-panel{
        .el-time-spinner__list::after, .el-time-spinner__list::before{
            height:70px;
        }
    }

    .scrollbar_style{
        margin-right: 8px;
        overflow: auto;
    }
      /*.scrollbar_style::-webkit-scrollbar-button{
         width: 10px;
         height: 10px;
      }*/
    .scrollbar_style::-webkit-scrollbar {/*滚动条整体样式*/
        width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 10px;
    }
    .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 8px;
        background: #DAE6E0;
    }
    .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    .cn{
        .el-checkbox__input{
            &.is-checked .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }
            &.is-indeterminate .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }

        }
    }
    #app{
        // margin: 0 auto;
        min-width: 1260px;
        overflow-y: auto; 
        overflow-x: hidden; 
        // max-width: 2400px;
        position: relative;
        .box_width{
            position: relative;
            min-width: 1440px;
        }
        input::-webkit-input-placeholder {
            font-family: AlibabaPuHuiTiR;
            /* placeholder颜色  */
            // color: #aab2bd;
            /* placeholder字体大小  */
            // font-size: 19px;
            /* placeholder位置  */
            // text-align: right;
        }
        .el-checkbox__label,.el-table__empty-text,.btn{
            font-family: AlibabaPuHuiTiR;
        }
        >.router_box{
            width: calc(100%);
            height: 100%;

        }
        .text1{
            font-family: PingFang SC, PingFang-SC-Medium;
        }
        .text2{
            font-family: PingFang SC, PingFang-SC-Bold;
        }
        .text3{
            font-family: PingFang SC, PingFang-SC-Regular;
        }
        .text4{
            font-family: PingFang SC, PingFang-SC-Heavy;
        }
    }
</style>
